
















































import { Component, Vue, Prop } from 'vue-property-decorator';

import DropDownCardMenu from '@/componentsV2/molecules/DropDownCardMenu/DropDownCardMenu.vue';
import Table from '@/componentsV2/organisms/Table/Table.vue';
import ModalOptions, { ModalOptionsV2 } from '@/components/Modal/ModalOptions';

import { IDropDownCardMenu } from '@/models/dropdownCardMenu';
import eventBus from '@/utils/eventBus';
import LocationsService from '@/api/LocationsService';

export type Location = {
  id: string;
  cityAndState: string;
  address: string;
  phone?: string;
  phoneMask: string;
  phoneCountryCode: string;
  name: string;
  allowDeleteLocation: boolean;
  [key: string]: any;
};

type ContextMenuOption = Omit<IDropDownCardMenu, 'trigger'>;

@Component({
  components: {
    Table,
    DropDownCardMenu
  }
})
export default class LocationList extends Vue {
  @Prop({ default: () => [] }) list!: Location[];

  locationService = new LocationsService();
  locationIdToDelete = '';

  get tPrefix() {
    return 'business.locations.list';
  }

  get contextMenuOptions(): ContextMenuOption[] {
    return [
      {
        label: 'Delete',
        key: 'delete'
      }
    ];
  }

  get shouldShowLocationNameColumn() {
    return this.list.some(item => item.name);
  }

  created() {
    eventBus.$on('deleteLocation', this.handleDeleteLocation);
  }

  beforeDestroy() {
    eventBus.$off('deleteLocation', this.handleDeleteLocation);
  }

  openDeleteConfirmation(name: string) {
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        icon: 'none',
        hideCancelButton: true,
        confirmEvent: '',
        componentToRender: 'deleteLocationModal'
      }),
      {
        locationId: this.locationIdToDelete,
        locationName: name,
        onDeleteLocationConfirm: (isSuccess: boolean) => {
          if (isSuccess) {
            this.$notification('Location deleted');
            this.$emit('location-removed', this.locationIdToDelete);
          }

          this.locationIdToDelete = '';
        }
      }
    );
  }

  async handleDeleteLocation(confirm: boolean) {
    if (!confirm) return;

    try {
      this.$showLoaderWithLocker();

      const { status } = await this.locationService.remove(
        this.locationIdToDelete
      );

      if (status === 200) {
        this.$notification('Location deleted');
        this.$emit('location-removed', this.locationIdToDelete);
      }
    } finally {
      this.$hideLoader();
      this.locationIdToDelete = '';
    }
  }

  handleContextMenuItemClick(option: ContextMenuOption, location: Location) {
    const methods: Record<string, () => void> = {
      delete: () => {
        if (!location.allowDeleteLocation) {
          this.$notification('Could not remove all addresses.', 'error');
          return;
        }
        this.locationIdToDelete = location.id;

        this.openDeleteConfirmation(
          `${location.address}, ${location.city}, ${location.state}`
        );
      }
    };

    if (!methods[option.key]) return;

    methods[option.key]();
  }
}
